import { post } from './httpHelpers'

export const postChatQuery = async (caseId: string, question: string) => {
  return await post<string>(`cases/chat/${caseId}`, { prompt: question }).then(
    (response) => response.parsedBody!['answer']
  )
}
